<template>
    <div class="setting-component">

        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <!--<div class="nav-tree">-->
                    <!--<el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">Add GL Account Class</el-button>-->
                <!--</div>-->
                <el-table
                        max-height="650"
                        ref="singleTable"
                        highlight-current-row
                        :empty-text="$t('general_noData')"
                        @current-change="handleCurrentChange"
                        :data="tableData"
                        style="width: 100%"
                        row-key="id"
                        default-expand-all>
                    <el-table-column
                            prop="classId"
                            :label="$t('settings_accountThink_GLAccountClasses_classId')">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            :label="$t('settings_accountThink_GLAccountClasses_className')">
                    </el-table-column>
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccountClasses_classType')">
                        <template slot-scope="scope">
                            <div class="value">{{ scope.row.class.className }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="150"
                            :label="$t('settings_accountThink_GLAccountClasses_operations')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    @click="handleEdit(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- Add -->
        <sweet-modal blocking title="Add GL Account Class" ref="openModal" class="modal" v-on:close="closeModal">
            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_GLAccountClasses_className')" v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item prop="classId">
                    <el-input type="number" :label="$t('settings_accountThink_GLAccountClasses_classId')" v-model="form.classId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input :label="$t('settings_accountThink_GLAccountClasses_classType')" v-model="form.classType"></el-input>
                </el-form-item>

                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- Edit -->
        <sweet-modal blocking title="Edit GL Account Class" ref="openModalEdit"  class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_GLAccountClasses_className')" v-model="formEdit.name"></el-input>
                </el-form-item>
                <el-form-item prop="classId">
                    <el-input disabled type="number" :label="$t('settings_accountThink_GLAccountClasses_classId')" v-model="formEdit.classId"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input disabled :label="$t('settings_accountThink_GLAccountClasses_classType')" v-model="formEdit.classType"></el-input>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- Are you sure? -->
        <!--<sweet-modal blocking ref="confirmation" :title="`Delete ` + btnText">-->
            <!--Are you sure you want to delete this {{btnText}}?-->
            <!--<template slot="box-action">-->
                <!--<el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;-->
            <!--</template>-->
        <!--</sweet-modal>-->

    </div>
</template>

<script>
  import _ from 'lodash'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'settingGLAccountClasses',
    components: {
      // Header,
      // Menu,
      SweetModal,

    },
    data() {
      return {
        btnText: 'GL Account Class',
        tableData: [],
        selectedRowId: '',
        moment:moment,
        classTypeList: [],
        form:{
          classId: '',
          name: '',
          classType: '',
        },
        formEdit:{
          classId: '',
          name: '',
          classType: '',
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          classId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          classTypeId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        modalDel:false,
        currentRow: null,

      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        console.log('---handleCurrentChange', val);
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountClasses/list?companyId=${this.$route.query.companyId}`)
          .then(response => {

            // this.tableData = list
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, index, row){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountClasses/directories?companyId=${this.$route.query.companyId}`)
          .then(response => {
            if(operation === 'create'){
              this.classTypeList = response.data.classTypeList
              this.$refs.openModal.open()
            }else if(operation === 'update'){
              this.classTypeList = response.data.classTypeList
              this.handleEdit(index, row)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/create
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              classId: this.form.classId,
              name: this.form.name,
              classTypeId: this.form.classTypeId
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccountClasses/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification("Success", `Add ${this.btnText}`, "success");
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      closeModal(){
        this.form.name = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.$refs['formEdit'].resetFields();
      },
      // * companyChartOfAccountItems/item
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountClasses/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.classId = response.data.item.classId
            this.formEdit.classType = response.data.item.class.className
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/update
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              name: this.formEdit.name,
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccountClasses/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, data)
              .then(response => {
                this.notification("Success", `Edit ${this.btnText}`, "success");
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the chart of account. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/glAccountClasses/delete?companyId=${this.$route.query.companyId}&glAccountClassId=${this.selectedRowId}`)
            .then(response => {
              this.$refs.confirmation.close()
              this.loadList()
              this.notification("Success", `Delete ${this.btnText}`, "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      // * companyChartOfAccountItems/delete
      // deleteConfirm(){
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //     .post(`/api/v1/companyChartOfAccountItems/delete?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${this.selectedRowId}`)
      //     .then(response => {
      //       this.$refs.confirmation.close()
      //       this.loadList()
      //       this.notification("Success", `Delete ${this.btnText}`, "success");
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
</style>
